var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState } from "react";
import { getProperties } from "../../resources/helper/properties";
/**
 * Properties de la categoría activa. Se piden por `entityName`, nunca por
 * registro: PropertiesAFY filtra por `entityId` para la tabla y usa la lista
 * completa para los contadores del listado de registros.
 */
export var usePropertiesGetAll = function (entityName) {
    var page = useState(1)[0];
    var limit = useState(100)[0];
    var _a = useState([]), responseProperties = _a[0], setResponseProperties = _a[1];
    var _b = useState(false), loadingProperties = _b[0], setLoadingProperties = _b[1];
    var _c = useState(null), errorProperties = _c[0], setErrorProperties = _c[1];
    var getPropertiesByEntity = useCallback(function (name) { return __awaiter(void 0, void 0, void 0, function () {
        var target, response, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    target = ((_a = name !== null && name !== void 0 ? name : entityName) !== null && _a !== void 0 ? _a : "").trim();
                    if (!target)
                        return [2 /*return*/];
                    setLoadingProperties(true);
                    setErrorProperties(null);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getProperties(target, page, limit)];
                case 2:
                    response = _c.sent();
                    setResponseProperties(((_b = response === null || response === void 0 ? void 0 : response.data) !== null && _b !== void 0 ? _b : []));
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _c.sent();
                    setErrorProperties(error_1);
                    setResponseProperties([]);
                    return [3 /*break*/, 5];
                case 4:
                    setLoadingProperties(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [entityName, page, limit]);
    useEffect(function () {
        getPropertiesByEntity();
    }, [getPropertiesByEntity]);
    return {
        responseProperties: responseProperties,
        errorProperties: errorProperties,
        loadingProperties: loadingProperties,
        getPropertiesByEntity: getPropertiesByEntity,
    };
};
